// import * as R from 'ramda'
import { getTimeWithI18n } from '@Bill/utils'
import { getSuggestRuleConfig } from '@Bill/constants'
import i18n from '@/locales'
import { getTagTitle } from '@/utils/common/tag'

export const getSettingTableColumn = () => {
  return {
    field: 'setting',
    title: i18n.t('bill.text_174'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        let type = ''
        if (row.type.includes('UP_DOWN_')) {
          type = 2
        } else if (row.type.includes('_UNUSED')) {
          type = 1
        } else {
          type = 3
        }
        const setting = row.setting?.scale_rule ? row.setting?.scale_rule[0] : {}
        return getSuggestRuleConfig({
          type,
          resource_type: row.res_type,
          time_from: row.time_from,
          ...setting,
        }).rule
      },
    },
  }
}

export const getPeriodTableColumn = () => {
  return {
    field: 'period',
    title: i18n.t('bill.text_189'),
    minWidth: 70,
    showOverflow: 'title',
    formatter: ({ row, cellValue }) => {
      return getTimeWithI18n(row.period)
    },
  }
}

export const getTimeFromTableColumn = () => {
  return {
    field: 'time_from',
    title: i18n.t('bill.text_198'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      header: ({ column }, h) => {
        return [
          <a-tooltip>
            <template slot="title">
              <div>{ i18n.t('bill.time_from_header_tips') }</div>
            </template>
            <span class='mr-1'>{ column.title }</span>
            <icon type="question" />
          </a-tooltip>,
        ]
      },
      default: ({ row }, h) => {
        let time = getTimeWithI18n(row.time_from)
        if (row.time_range) {
          time += `(${row.time_range})`
        }
        const ret = [
          <div class='text-truncate' title={ time }>
            { time }
          </div>,
        ]
        if (row.skip_holidays) {
          ret.push(<div class='text-truncate'>
            { i18n.t('meter.exclude_holidays') }
          </div>)
        }
        return ret
      },
    },
  }
}

export const getExecTimeTableColumn = ({ vm }) => {
  return {
    field: 'exec_time',
    title: i18n.t('bill.text_218'),
    minWidth: 70,
    showOverflow: 'title',
    formatter: ({ row, cellValue }) => {
      if (!cellValue) {
        return '-'
      }
      return vm.$moment(cellValue).fromNow()
    },
  }
}

export const getTypeTableColumn = () => {
  return {
    field: 'type',
    title: i18n.t('bill.text_175'),
    minWidth: 70,
    showOverflow: 'title',
    formatter: ({ row }) => {
      let type = ''
      if (row.type.includes('_UNUSED')) {
        type = 1
      } else if (row.type.includes('UP_DOWN_')) {
        type = 2
      } else {
        type = 3
      }
      return getSuggestRuleConfig({ type, resource_type: row.res_type, adjust_ratio: row.adjust_ratio }).method
    },
  }
}

export const getApplyScopeTableColumn = () => {
  return {
    field: 'target_type',
    title: i18n.t('bill.apply_scope'),
    minWidth: 70,
    slots: {
      default: ({ row }, h) => {
        const { target_type = '', target_ids = [], target_names = [] } = row
        if (target_type === 'system') {
          return i18n.t('shareScope.system')
        } else if (target_type === 'domain' || target_type === 'project') {
          const names = target_names.filter(item => !!item).join(',')
          return i18n.t(`shareScope.${target_type}`) + ': ' + names
        } else if (target_type === 'project_tags') {
          const ret = [<span>{ i18n.t('dictionary.organization') }:</span>]
          target_ids.map(str => {
            const s = str.replace('user:', '').split('=')
            ret.push(<a-tag class="mr-1 mb-1">{getTagTitle(s[0], s[1]) }</a-tag>)
          })
          return [<span>{...ret}</span>]
        }
        return '-'
      },
    },
    formatter: ({ row }) => {
      const { target_type = '', target_names = [], target_ids = [] } = row
      if (target_type === 'system') {
        return i18n.t('shareScope.system')
      } else if (target_type === 'domain' || target_type === 'project') {
        const names = target_names.filter(item => !!item).join(',')
        return i18n.t(`shareScope.${target_type}`) + ': ' + names
      } else if (target_type === 'project_tags') {
        let str = i18n.t('dictionary.organization') + ':'
        target_ids.map((item, index) => {
          const s = item.replace('user:', '').split('=')
          str = str + (index === 0 ? '' : ', ') + s
        })
        return str
      }
      return '-'
    },
  }
}
